/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app'
import 'firebase/auth'

import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                props: true,
                component: () => import('./views/ItemHistory.vue'),
                meta: {
                  pageTitle: '商品履歴',
                  readFirebaseItem: 'items'
                }
              },
              {
                path: '/stocks',
                name: 'stocks',
                props: true,
                component: () => import('./views/StockHistory.vue'),
                meta: {
                  pageTitle: '仕入れ',
                  readFirebaseItem: 'stocks'
                }
              },
              {
                path: '/search',
                name: 'search',
                props: true,
                component: () => import('./views/ItemSearch.vue'),
                meta: {
                  pageTitle: '検索',
                  readFirebaseItem: 'search'
                }
              },
              {
                path: '/search-history',
                name: 'searchHistory',
                props: true,
                component: () => import('./views/SearchHistory.vue'),
                meta: {
                  pageTitle: '検索履歴',
                  readFirebaseItem: 'searchHistory'
                }
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              /*
              {
                path: '/pages/forgot-password',
                name: 'page-forgot-password',
                component: () => import('@/views/pages/ForgotPassword.vue')
              },
              */
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
              {
                path: '/authorize',
                name: 'authorize',
                component: () => import('./views/pages/Authorize.vue'),
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],


    watch: {
      "$route"() {
        this.readFirebaseItem = this.$route.meta.readFirebaseItem
      }
    },
    data (){
      return {
        readFirebaseItem: this.$route.meta.readFirebaseItem
      }
    }
})

/*
router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }


  firebase.auth().onAuthStateChanged(() => {
    const firebaseCurrentUser = firebase.auth().currentUser
    const self = this
    const client_id = to.query.client_id
    // ログインしていたら
    if (store.state.auth.isUserLoggedIn()) {
      
      if (typeof client_id != 'undefined' && client_id != '' && client_id != null) {
        if (to.path != '/authorize') {
          router.push( { name: 'authorize', query: to.query } )
          //return next({path:'/authorize',query:to.query})
        }
      } else {
        // Amacode Proのフラグチェック
        const dbProfileRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/ispro')
        dbProfileRef.on('value', (data) => {
          if (!data.val()) {
            const firebaseCurrentUser = firebase.auth().currentUser
            if (firebaseCurrentUser) {
              firebase.auth().signOut().then(() => {
                let paramQ = to.query
                paramQ.state = 0
                router.push( { name: 'page-login', query: paramQ } )
                //return next({path:'/pages/login',query:paramQ})
              })
            }
          } else {
            if (to.path === '/pages/login') {
              router.push( { name: 'home', query: to.query } )
              //return next({path:'/',query:to.query})
            }
          }
        })
      }
    // ログインしていなかったら
    } else {
      // ログインページ以外であれば、ログインページへリダイレクト
      if (to.path !== '/pages/login') {
        router.push( { name: 'page-login', query: to.query } )
        //return next({path:'/pages/login',query:to.query})
      }
    }
  })
})

router.beforeEach((to, from, next) => {

  firebase.auth().onAuthStateChanged(() => {
    /*
    const firebaseCurrentUser = firebase.auth().currentUser
    if (store.state.auth.isUserLoggedIn()) {
      const self = this
      // Amacode Proのフラグチェック
      const firebaseCurrentUser = firebase.auth().currentUser
      const dbProfileRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/ispro')
      dbProfileRef.on('value', (data) => {
        if (!data.val()) {
          const firebaseCurrentUser = firebase.auth().currentUser
          if (firebaseCurrentUser) {
            firebase.auth().signOut().then(() => {
              let paramQ = to.query
              paramQ.state = 0
              return next({path:'/pages/login',query:paramQ.state})
            })
          } else {
            return next()
          }
        } else {
          if (to.path == '/pages/login') {
            return next('/')
          }
        }
      })
      
    } else {
      // ログインページ以外であれば、ログインページへリダイレクト
      if (to.path !== '/pages/login') {
        return next({path:'/pages/login',query:to.query})
      } else {
        return next()
      }
    }
    * /
    return next()
  })

  //return next()
})
*/

router.afterEach((to) => {
  //console.log("afterEach  aaaa")
  //console.log(firebase.auth().currentUser)
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
      appLoading.style.display = "none";
  }

  firebase.auth().onAuthStateChanged(() => {
    //console.log("afterEach onAuthStateChanged")
    const firebaseCurrentUser = firebase.auth().currentUser
    const self = this
    
    // ログインしていたら
    if (store.state.auth.isUserLoggedIn()) {
      //console.log("afterEach isUserLoggedIn")
      // Amacode Proのフラグチェック
      const dbProfileRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/ispro')
      dbProfileRef.on('value', (data) => {
        // isproがない場合
        if (!data.val()) {
          const firebaseCurrentUser = firebase.auth().currentUser
          if (firebaseCurrentUser) {
            firebase.auth().signOut().then(() => {
              router.push( { name: 'page-login', query: {state:0} } )
              //return next({path:'/pages/login',query:{state:0}})
            })
          } else {
            //return next()
          }
        } else {
          // isProがある


          // urlパラメータのclient idがある場合
          const client_id = to.query.client_id
          if (typeof client_id != 'undefined' && client_id != '' && client_id != null) {
            if (to.path != '/authorize') {
              router.push( { name: 'authorize', query: to.query } )
              //return next({name:'authorize',query:to.query})
            } else {
              //return next()
            }
          } else {
            // ログインしていてログインページの場合はhome画面へリダイレクト
            if (to.path === '/pages/login') {
              router.push( { name: 'home', query: to.query } )
              //return next({path:'/',query:to.query})
            } else {
              //return next()
            }
          }

          
        }
      })
    // ログインしていなかったら
    } else {
      //console.log("afterEach not isUserLogged")
      // ログインページ以外であれば、ログインページへリダイレクト
      if (to.path !== '/pages/login') {
        router.push( { name: 'page-login', query: to.query } )
        //return next({path:'/pages/login',query:to.query})
      } else {
        //return next()
      }
    }
  })
})

router.beforeEach((to, from, next) => {
  //console.log("beforeEach")
  //console.log(firebase.auth().currentUser)
  // ログインしていなかったら
/*
    if (!store.state.auth.isUserLoggedIn()) {
      // ログインページ以外であれば、ログインページへリダイレクト
      if (to.path !== '/pages/login') {
        router.push( { name: 'page-login', query: to.query } )
        //return next({path:'/pages/login',query:to.query})
      }
    }
*/
  /*
  // ■ apple IDの課金状況のチェック
  const firebaseCurrentUser = firebase.auth().currentUser
  const self = this
  
  // ログインしていたら
  if (store.state.auth.isUserLoggedIn()) {
    // Amacode Proのフラグチェック
    const dbProfileRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/ispro')
    dbProfileRef.on('value', (data) => {
      // isproがない場合
      if (data.val()) {
        console.log('appleAuthCheck')
        //this.updatedCheck = false
        //this.updatedCheck = true
        // setintervalで6時間ごとに関数を走らせて状態をチェックをする
        const self = this
        const planId = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/planId')
        planId.once('value', function(snapshot) {
          // planidがappleの場合
          if (snapshot.val() === 'apple') {
            console.log('apple')
            var appleReceiptAuth = firebase.functions().httpsCallable('appleReceiptAuth')
            const appleReceiptAuthCall = async (value) => {
              appleReceiptAuth().then(function(result) {
                // NG（課金されていない）時
                if (result.data.result === 'NG') {
                  //console.log(self.$vs)
                  // アラートでMSGを表示
                  /*
                  self.$vs.dialog({
                    color:'danger',
                    title: 'アカウント エラー',
                    text: result.data.msg,
                    acceptText: '閉じる',
                    buttonsHidden: true,
                  })
                  * /
                  setInterval(self.appleAuthCheck, 5000)
                } else {
                  //setInterval(self.appleAuthCheck, 60000 * 60 * 6)
                  setInterval(self.appleAuthCheck, 5000)
                }
                return result
              })
            }
            appleReceiptAuthCall().then(result => {})
          }
        })
      }
    })
  }
  */

  firebase.auth().onAuthStateChanged(() => {
    return next()
  })
})


export default router
